import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'setFilter'
})
export class SetFilterPipe implements PipeTransform {
  transform(value: { isVisible: boolean }[], filter: string): any[] {
    if (!filter) return value;
    return value.filter(v => v.isVisible);
  }
}
